var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconDefinition4K(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 10,
    viewBox: "0 0 12 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_20120_241606)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12,
    height: 9.6,
    rx: 1.2,
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.2 0C0.537258 0 0 0.537258 0 1.2V8.4C0 9.06274 0.537259 9.6 1.2 9.6H10.8C11.4627 9.6 12 9.06274 12 8.4V1.2C12 0.537258 11.4627 0 10.8 0H1.2ZM1.40632 5.2704V6.264H3.82552V7.2H5.05672V6.264H5.64712V5.1984H5.05672V2.016H3.68152L1.40632 5.2704ZM2.70232 5.1984L3.91192 3.3696V5.1984H2.70232ZM7.60377 4.968L9.30297 7.2H10.8078L8.77737 4.6224L10.7358 2.1456H9.28857L7.60377 4.3632V2.1456H6.37257V7.2H7.60377V4.968Z",
    fill: "#FF443A",
    className: "red"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_20120_241606"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12,
    height: 9.6,
    rx: 1.2,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconDefinition4K);
export default __webpack_public_path__ + "static/media/icon-definition-4k.3d7e5aa244411b5d8dda2d3aa2c70fc2.svg";
export { ForwardRef as ReactComponent };